import { mapState } from 'vuex'
import format from 'date-fns/format'
import ko from 'date-fns/locale/ko'

let timer

export default {
  created () {
    timer = setInterval(() => {
      this.now = Date.now()
    }, 1000)
  },

  data () {
    return {
      now: Date.now()
    }
  },

  computed: {
    ...mapState('room', [
      'room'
    ]),

    timestamp () {
      return format(
        this.now, 'M/DD/dd HH:mm:ss', { locale: ko }
      )
    },

    runningTime () {
      return format(
        this.now - this.room.startedAt, 'mm:ss', { locale: ko }
      )
    }
  },

  methods: {
    stopTimer () {
      clearInterval(timer)
    }
  }
}
